import React from 'react';
import { Box, Checkbox } from '@mui/material';
import { Typography, colors } from '@leapeasy/ui-kit';
import { SELECTOR_CHECKBOX_SX } from './InviteTableColumns';

export const InvitePropertySelectAllBar = ({
  allSelected,
  partiallySelected,
  onToggle,
  visibleCount = 0,
  hasSearch = false,
  loading = false,
}) => {
  if (!visibleCount) {
    return null;
  }

  const countLabel = hasSearch
    ? `${visibleCount} matching ${visibleCount === 1 ? 'property' : 'properties'}`
    : `${visibleCount} ${visibleCount === 1 ? 'property' : 'properties'}`;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        px: '16px',
        py: '12px',
        backgroundColor: '#F8F4F9',
        borderBottom: '1px solid #EAEAEA',
      }}
    >
      <Box
        component="label"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '10px',
          cursor: 'pointer',
          userSelect: 'none',
          minWidth: 0,
        }}
      >
        <Checkbox
          disableRipple
          sx={SELECTOR_CHECKBOX_SX}
          checked={allSelected}
          indeterminate={partiallySelected}
          onChange={onToggle}
          disabled={loading}
          inputProps={{ 'aria-label': 'Select all matching properties' }}
        />
        <Typography
          variant="body2"
          style={{ fontWeight: 600, color: colors.purple[900], whiteSpace: 'nowrap' }}
        >
          {loading ? 'Selecting…' : 'Select All'}
        </Typography>
      </Box>
      <Typography
        variant="body3"
        style={{ color: colors.neutral[700], marginLeft: 'auto', whiteSpace: 'nowrap' }}
      >
        {countLabel}
      </Typography>
    </Box>
  );
};
